const { getDate } = require('./getDate')

/**
 * Visszaadja az aktuális évet és hónapot, a hónap első napjával.
 * @example 2024-01-01
 * @returns {string} Az aktuális év és hónap, a hónap első napjával.
 */
module.exports.getCurrentDateWithFirstDay = function getCurrentDateWithFirstDay () {
  const date = new Date()
  const firstDay = getDate(new Date(date.getFullYear(), date.getMonth(), 1))

  return firstDay
}
